import { useLocation } from 'react-router-dom';

export const useBasePath = () => {
    const location = useLocation();

    // Split the pathname by "/" and take the first part
    const basePath = location.pathname.split('/')[1];

    return `/${basePath}`;
}